import React, { useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { deleteAssetType } from "../../../graphql/mutations";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";

import { Button } from "react-admin";

import classnames from "classnames";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { deepRedirect } from "../../../utils/utils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteAssetTypeButton = ({
  record,
  eventTypes,
  backPath,
  history,
  notify,
  isDisabled,
  className,
}) => {
  const classes = useStyles();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async (event) => {
    debugger;
    if (eventTypes?.length > 0) {
      notify("Asset linked to an Event cannot be deleted.", "warning");
      return;
    }

    try {
      setIsDeleting(true);
      await API.graphql(
        graphqlOperation(deleteAssetType, { input: { id: record.id } }),
      );
      notify("Asset type deleted successfully", "success");
      const tab = history.location.state.tab;
      deepRedirect(history, backPath, null, { tab });
    } catch (error) {
      logError(
        "assetTypes:DeepDeleteAssetTypeButton:handleDelete",
        error,
        notify,
      );
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Button
      label="Delete"
      disabled={!record || isDeleting || isDisabled}
      onClick={handleDelete}
      className={classnames(
        "ra-delete-button",
        classes.deleteButton,
        className,
      )}
    >
      <DeleteIcon />
    </Button>
  );
};
